import { RoutePath } from './Routes';

export const ApplicationStepName: Record<RoutePath, string> = Object.freeze({
  [RoutePath.Goals]: 'Goals',
  [RoutePath.ExitSurvey]: 'Exit Survey',
  [RoutePath.YourName]: 'Your Name',
  [RoutePath.ConfirmYourCredentials]: 'Your Professional Credentials',
  [RoutePath.YourAddress]: 'Your Address',
  [RoutePath.SmsLogin]: 'SMS Login',
  [RoutePath.LoanAmountRange]: 'Loan Amount Range',
  [RoutePath.CreditScoreRange]: 'Credit Score Range',
  [RoutePath.Location]: 'Location',
  [RoutePath.ConfirmLoan]: 'Confirm Loan',
  [RoutePath.OfferStatus]: 'Offer Status',
  [RoutePath.UnfreezeCreditScore]: 'Unfreeze Credit Score',
  [RoutePath.BureauVerification]: 'Bureau Verification',
  [RoutePath.ExtendedIdentityCheck]: 'Extended Identity Check',
  [RoutePath.ExtendedIdentityAddresses]: 'Extended Identity Addresses',
  [RoutePath.EmailNotificationAlert]: 'Email Notification Alert',
  [RoutePath.DocuSignSignature]: 'DocuSignSignature',
  [RoutePath.RepaymentMethod]: 'Repayment Method',
  [RoutePath.OpenDDA]: 'Open DDA',
  [RoutePath.SetupDeduction]: 'Setup Deduction',
  [RoutePath.SetupViaPayroll]: 'Setup Via Payroll',
  [RoutePath.WhatIsTheIssue]: 'What Is The Issue?',
  [RoutePath.NotifyYourTeam]: 'Notify Your Team',
  [RoutePath.VerifyPayrollDeduction]: 'Verify Payroll Deduction',
  [RoutePath.PaystubsSignInGuide]: 'Paystubs Sign In Guide',
  [RoutePath.FundsSent]: 'Funds Sent',
  [RoutePath.BankAccount]: 'Bank Account',
  [RoutePath.Plaid]: 'Plaid',
  [RoutePath.PlaidCheckingAccounts]: 'Plaid Checking Accounts',
  [RoutePath.UploadIncomeVerification]: 'Upload Income Verification',
  [RoutePath.OutOfState]: 'Out of State',
  [RoutePath.Offer]: 'Offer',
  [RoutePath.YourBirthDate]: 'BirthDate',
  [RoutePath.SetupAccount]: 'SetupAccount',
  [RoutePath.VerificationSteps]: 'VerificationSteps',
  [RoutePath.SelectDebts]: 'Select Debts',
  [RoutePath.FinalizeAdditionalFunds]: 'Extra Funds',
  [RoutePath.FinalizeReviewOffer]: 'Review Offer',
  [RoutePath.Feedback]: 'Feedback',
  [RoutePath.VerifyingApplication]: 'Verifying Application',
  [RoutePath.VerifyingKyc]: 'Verifying Identity',
  [RoutePath.VerifyIncome]: 'Verify Income',
  [RoutePath.Alloy]: 'Alloy',
  [RoutePath.YourGoal]: 'YourGoal',
  [RoutePath.OpenDDADone]: 'Open DDA Done',
  [RoutePath.CardApplied]: 'Card Applied',
  [RoutePath.Error]: 'Error',
  [RoutePath.Logout]: 'Logout',
  [RoutePath.AdditionalFunds]: 'Additional Funds',
  // Financial Checkup
  [RoutePath.YourPhoneNumber]: 'Your Phone Number',
  [RoutePath.VerifyPhoneNumber]: 'Verify Phone Number',
  [RoutePath.YourEmail]: 'Your Email',
  [RoutePath.VerifyEmail]: 'Verify Email',
  [RoutePath.YourIncome]: 'Your Income',
  [RoutePath.YourSSN4]: 'Your Social Security Number 4',
  [RoutePath.YourEmployer]: 'Your Employer',
  [RoutePath.AdditionalIncome]: 'Additional Income',
  [RoutePath.MethodAuth]: 'Method Auth',
  [RoutePath.Analyzing]: 'Analyzing',
  // Financial Dashboard
  [RoutePath.FinancialDashboard]: 'Financial Dashboard',
  [RoutePath.YourLoans]: 'Your Loans',
  [RoutePath.ManageYourLoan]: 'Manage Your Loan',
  [RoutePath.LoansHistory]: 'Loan History',
  // Card
  [RoutePath.CardInfo]: 'Card Info',
  [RoutePath.CardApplicationSuccessful]: 'Card Application Successful',
  [RoutePath.XSellLoader]: 'Loading',
  [RoutePath.ReferralProgram]: 'Referral Program',
  [RoutePath.ErrorConsolidating]: 'Error Consolidating',
  [RoutePath.ConnectPaycheck]: 'Connect Your Paycheck',
  [RoutePath.ConnectPaycheckFeedback]: 'Connect Paycheck Feedback',
  [RoutePath.BuildCreditAvoidDebtSaveMoney]: 'Card Overview',
  [RoutePath.CardRewards]: 'Card Rewards',
  [RoutePath.SmartSpending]: 'Smart Spending',
  [RoutePath.SmartAutoPay]: 'Smart Auto Pay',
  [RoutePath.ImportDebt]: 'Import Debt',
  [RoutePath.CardSummary]: 'Card Summary',
  [RoutePath.ApplyEmployeeLoan]: 'Apply Employee Loan',
  [RoutePath.ConfirmYourDetails]: 'Confirm Your Details',
  [RoutePath.StayInTouch]: 'Stay In Touch',

  // Missed Payments
  [RoutePath.MissedPayment]: 'Missed Payment',
  [RoutePath.MakeAPayment]: 'Make A Payment',
  [RoutePath.MissedPaymentReason]: 'Missed Payment Reason',
  [RoutePath.Authorization]: 'Authorization',
  [RoutePath.WaitingAuthorization]: 'Waiting Authorization',
  [RoutePath.MakingPayment]: 'Making Payment',
  [RoutePath.PaymentInitiated]: 'Payment Initiated',
  [RoutePath.PaymentFailed]: 'Payment Failed',
  // Student Loan
  [RoutePath.StudentLoanEmployer]: 'Student Loan Employer',
  [RoutePath.StudentLoanWork]: 'Student Loan Work',
  [RoutePath.StudentLoanHousehold]: 'Student Loan Household',
  [RoutePath.StudentLoanIncome]: 'Student Loan Income',
  [RoutePath.StudentLoanEstimate]: 'Student Loan Estimate',
  [RoutePath.StudentLoanUploadAidData]: 'Student Loan Upload Aid Data',
  [RoutePath.StudentLoanPlan]: 'Student Loan Plan',
  [RoutePath.StudentLoanSteps]: 'Student Loan Steps',
  [RoutePath.StudentLoanExploreMore]: 'Student Loan Explore More',
  [RoutePath.StudentLoanLater]: 'Student Loan Later',
  [RoutePath.StudentLoanBlocked]: 'Student Loan Blocked',
  [RoutePath.StudentLoanNotEligible]: 'Student Loan Not Eligible',
  [RoutePath.StudentLoanApplyStepsIntro]: 'Student Loan Apply Steps Intro',
  [RoutePath.StudentLoanApplySteps]: 'Student Loan Apply Steps',
  [RoutePath.StudentLoanApplyStepsCompleted]: 'Student Loan Apply Steps Completed',
  [RoutePath.StudentLoanServiceAgreementDone]: 'Student LoanService Agreement Done',
  // Debt Consolidation
  [RoutePath.OfferAvailable]: 'Offer Available',
  [RoutePath.AnalyzingUpdatedOffer]: 'Analyzing Offer',
  // Transaction Detail
  [RoutePath.MethodPayment]: 'Method Payment',
  [RoutePath.AvailableShifts]: 'Available Shifts',
  [RoutePath.ShiftDetails]: 'Shift Details',
  [RoutePath.LoanPayment]: 'Loan Payment',
  // AICoach
  [RoutePath.AICoachMonthlySavings]: 'Monthly Savings',
});
